
import Vue from 'vue';

export default Vue.extend({
	props: {
		id: { type: String, default: 'default-tooltip' },
		position: { type: String, default: 'right' },
		triggers: { type: String, default: 'hover' },
		variant: { type: String, default: 'info' },
	},
});
